<template>
    <section>
        <div id="ModalBuySMS" class="modal fade in" data-backdrop="false" data-keyboard="false" role="dialog">
            <div class="modal-dialog modal-el">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title"><i class="fa fa-cart-plus"></i> Comprar saldo de SMS</p>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-8">
                                <fieldset class="border p-2">
                                    <legend class="text-left w-auto"><i class="fa fa-credit-card"></i> Dados de
                                        pagamento
                                    </legend>
                                    <card-form ref="cardForm" :payment="request"></card-form>
                                </fieldset>
                            </div>
                            <div class="col-md-4">
                                <fieldset class="border p-2">
                                    <legend class="text-left w-auto"><i class="fa fa-shopping-cart"></i> Carrinho
                                    </legend>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <button @click="request.quantidade = parseInt(request.quantidade || 0) + 10"
                                                class="btn btn-app"><i class="fa fa-comment-o"></i>SMS 10x</button>
                                        </div>
                                        <div class="col-md-4">
                                            <button @click="request.quantidade = parseInt(request.quantidade || 0) + 50"
                                                class="btn btn-app"><i class="fa fa-comment-o"></i>SMS 50x</button>
                                        </div>
                                        <div class="col-md-4">
                                            <button
                                                @click="request.quantidade = parseInt(request.quantidade || 0) + 100"
                                                class="btn btn-app"><i class="fa fa-comment-o"></i>SMS 100x</button>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <required /><label :class="{ 'text-danger': errors.has('Quantidade') }">
                                                    Quantidade</label>
                                                <input v-validate="{required: true, min_value: 1}" name="Quantidade"
                                                    :class="{ 'is-invalid': errors.has('Quantidade') }"
                                                    @change="request.quantidade = (parseInt(request.quantidade) < 1 || !request.quantidade) ? 10 : parseInt(request.quantidade)"
                                                    v-model="request.quantidade" v-numericOnly
                                                    placeholder="Insira a quantidade" class="form-control">
                                                <div class="invalid-feedback help-block error">
                                                    {{errors.first('Quantidade')}}</div>
                                            </div>
                                        </div>
                                        <div class="col-6"><br>
                                            <small class="mt-3">
                                                <required /> Valor unitário do SMS é <b>{{formatMoney(valorUnitario)}}</b></small></div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-4"></div>
                                        <div class="col-8">
                                            <div class="form-group">
                                                <h4 class="text-right m-3">Total:
                                                    {{formatMoney(request.quantidade * valorUnitario)}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                                class="fa fa-times"></i>
                            {{ $t('words.cancel')}}</button>
                        <button type="button" @click="finalizar()" :disabled="loading"
                            class="btn btn-success float-right"><i class="fa fa-check"></i>
                            Confirmar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import cardForm from "../home/components/card-form.vue"
    export default {
        components: {
            cardForm,
        },
        data() {
            return {
                loading: false,
                valorUnitario: 0,
                request: {
                    quantidade: 0,
                    total: 0,
                    cardName: "",
                    cardNumber: "",
                    cardMonth: null,
                    cardYear: null,
                    cardCvv: "",
                    grecaptcha: "",
                },
            }
        },
        beforeMount() {
            this.$store.dispatch('getSMSModulePrice').then(response => {
                this.valorUnitario = response.valor;
            });
        },
        methods: {
            finalizar() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        return;
                    }
                    this.loading = true;
                    this.$store.dispatch('buySmsPackage', this.request).then(response => {
                       this.resetForm();
                       $('#ModalBuySMS').modal('toggle');
                        toastr({
                            icon: response.status,
                            title: response.message
                        })
                    }).catch(error => {
                        console.log(error);
                        toastr({
                            icon: error.status,
                            title: error.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            }
        }

    }
</script>